<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="hide" destroy-on-close>
			<template #default>
				<div>
					<div class="flex" style="flex-direction: row;">
						<datePicker v-model="date" style="width: 300px;margin-bottom: 10px;margin-right: 10px;" />
						<div style="width: 300px;margin-right: 10px;">
							<el-input size="mini" placeholder="输入商品链接或商品ID" v-model="goodsurl"
								style="margin-bottom: 20px;" clearable>
							</el-input>
						</div>
						<vxe-button @click="search" status="primary">查询</vxe-button>
						<vxe-button @click="reset" status="">重置</vxe-button>
					</div>
					<vxe-toolbar>
						<template #buttons>
							<el-button size="mini" @click="exportDataEvent">导出</el-button>
							<el-button size="mini" @click="copy">复制</el-button>
							<el-checkbox size="mini" v-model="needhead" border style="margin-left: 10px;">复制表头</el-checkbox>
							<el-button type="" size="mini" style="margin-left: 10px;" @click="task">任务</el-button>
							<buttonauth code="tool_competitivegoods" @buttonauthClick="buttonauthClick" />
						</template>
					</vxe-toolbar>
					<vxe-table height="550" resizable border :data="tableData" ref="competitivegoodsTable"
						:cellStyle="cellStyle" :row-config="{isCurrent: true, isHover: true}"
						:tree-config="{transform: true, rowField: 'id', parentField: 'parentId',expandAll: true}"
						:loading="loading">
						<vxe-column field="channelName" title="渠道" tree-node width="150" fixed="left"></vxe-column>
						<vxe-column field="click" title="整体点击量" width="100" sortable></vxe-column>
						<vxe-column field="clickRate" title="点击率(%)" width="100" sortable>
							<template #default="{ row }">
								<span>{{row.clickRate ? (row.clickRate * 100).toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="cartRate" title="整体加购率(%)" width="100" sortable>
							<template #default="{ row }">
								<span>{{row.cartRate ? (row.cartRate * 100).toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="alipayConversion" title="整体成交转化率(%)" width="100" sortable>
							<template #default="{ row }">
								<span>{{row.alipayConversion ? (row.alipayConversion * 100).toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="gmv" title="整体成交金额" width="100" sortable>
							<template #default="{ row }">
								<span>{{row.gmv ? row.gmv.toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="alipayCnt" title="整体成交笔数" width="100" sortable>
							<template #default="{ row }">
								<span>{{row.alipayCnt ? row.alipayCnt.toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="averageOrderValue" title="整体笔单价" width="100" sortable>
							<template #default="{ row }">
								<span>{{row.averageOrderValue ? row.averageOrderValue.toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="paidClickRate" title="付费点击占比(%)" width="100" sortable>
							<template #default="{ row }">
								<!-- <span>{{row.paidClickRate ? (row.paidClickRate * 100).toFixed(2) : null}}</span> -->
								<span>{{(row.click && row.paidClick) ? (row.paidClick/row.click * 100).toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="clickCost" title="单次点击成本" width="100" sortable>
							<template #default="{ row }">
								<span>{{row.clickCost ? row.clickCost.toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="roi1d" title="当天引导ROI" width="100" sortable>
							<template #default="{ row }">
								<span>{{row.roi1d ? row.roi1d.toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="gmv1d" title="当天引导成交金额" width="100" sortable>
							<template #default="{ row }">
								<span>{{row.gmv1d ? row.gmv1d.toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="gmvAd" title="广告引导成交金额" width="100" sortable>
							<template #default="{ row }">
								<span>{{row.gmvAd ? row.gmvAd.toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="paidClick" title="付费点击量" width="100" sortable></vxe-column>
						<vxe-column field="buyCrowdGmvRate" title="buyCrowdGmvRate" width="100" sortable>
							<template #default="{ row }">
								<span>{{row.buyCrowdGmvRate ? (row.buyCrowdGmvRate * 100).toFixed(2) : null}}</span>
							</template>
						</vxe-column>
						<vxe-column field="cost" title="推广成本" width="100" fixed="right" sortable>
							<template #default="{ row }">
								<span>{{ getcost(row)  }}</span>
								<!-- <span>{{row.cost ? row.cost.toFixed(2) : null}}</span> -->
							</template>
						</vxe-column>
						<vxe-column field="payRate" title="付费占比(%)" width="100" fixed="right" sortable>
							<template #default="{ row }">
								<span>{{getpayrate(row)}}</span>
							</template>
						</vxe-column>
						<vxe-column field="module" title="模块" width="150" fixed="right"></vxe-column>
						<vxe-column field="goodscode" title="商品ID" width="100"></vxe-column>
						<vxe-column field="goodsurl" title="链接" width="100" show-overflow="ellipsis">
							<template #default="{ row }">
								<el-link type="primary" :href="row.goodsurl" target="_blank">{{row.goodsurl}}</el-link>
							</template>

						</vxe-column>
						<vxe-column field="beginDate" title="开始日期" width="100"></vxe-column>
						<vxe-column field="endDate" title="结束日期" width="100"></vxe-column>
					</vxe-table>


					<!-- 					<el-divider content-position="center">流量分析——全域归因</el-divider>
					<vxe-table border :align="allAlign" :data="tableData">
						<vxe-column type="seq" width="50"></vxe-column>
						<vxe-column field="name" title="分析对象"></vxe-column>
						<vxe-column field="value" title="数据"></vxe-column>
					</vxe-table>
					<el-divider content-position="center">流量分析——广告归因</el-divider>
					<vxe-table border :align="allAlign" :data="tableData">
						<vxe-column type="seq" width="50"></vxe-column>
						<vxe-column field="name" title="分析对象"></vxe-column>
						<vxe-column field="value" title="数据"></vxe-column>
					</vxe-table> -->
					<taskIndex  ref="taskIndex" />
					<systemtaskIndex  ref="systemtaskIndex" />
				</div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
		
		
		
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	import taskIndex from './task/index.vue'
	import systemtaskIndex from './systemtask/index.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			currentrow: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model: true,
				modal_title: '竞品透视',
				modal_width: 1200,
				modal_height: 800,
				goodsurl: null,
				tableData: [],
				date: null,
				loading: false,
				needhead:false,
				buttonauth:[]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			this.date = [
				this.$Moment().subtract(7, 'days').startOf('day').valueOf(),
				this.$Moment().subtract(1, 'days').endOf('day').valueOf(),
			]
		},
		methods: {
			buttonauthClick(code){
				if(this[code]){
					this[code]()
				}
			},
			systemtask(){
				this.$refs.systemtaskIndex.modal_show()
			},
			task(){
				this.$refs.taskIndex.modal_show()
			},
			cellStyle({
				row
			}) {
				if (row.moduletype == 'base') {
					return {
						backgroundColor: 'rgb(244, 244, 245)'
					}
				}
				if (row.moduletype == 'flowtotal') {
					return {
						backgroundColor: 'rgb(240, 249, 235)'
					}
				}
				if (row.moduletype == 'flowad') {
					return {
						backgroundColor: 'rgb(253, 246, 236)'
					}
				}
			},
			copy() {
				let head = [
					'店铺',
					'链接ID',
					'商品名称',
					'整体点击量',
					'整体成交转化率(%)',
					'整体成交金额',
					'整体成交笔数',
					'整体笔单价',
					'推广成本',
					'付费占比(%)',
					'单次点击成本',
					'当天引导ROI',
					'当天引导成交金额',
					'关键词推广点击量',
					'关键词推广转化率',
					'关键词推广成交笔数',
					'关键词推广当天引导ROI',
					'全站推广点击量',
					'全站推广转化率(%)',
					'全站推广成交笔数',
					'全站推广当天引导ROI',
					'开始日期',
					'结束日期'
				]
				let data = []
				let tabledata = this.$refs.competitivegoodsTable.getTableData().fullData
				if(!tabledata.length){
					this.$message.error('暂无可复制内容')
					return
				}
				//console.log(tabledata)
				let tempdata = head.map(()=>{
					return ''
				})
				tabledata.forEach( (item) => {
					if(item.module == '基础分析_核心指标'){
						tempdata[1] = item.goodscode
						tempdata[3] = item.click
						tempdata[4] = item.alipayConversion
						tempdata[5] = item.gmv
						tempdata[6] = item.alipayCnt
						tempdata[7] = item.averageOrderValue
						tempdata[8] = this.getcost(item)
						tempdata[9] = this.getpayrate(item)
						tempdata[10] = item.clickCost
						tempdata[11] = item.roi1d
						tempdata[12] = item.gmv1d
						
						tempdata[21] = item.beginDate
						tempdata[22] = item.endDate

					}
					if(item.module == '流量分析_全域归因' && item.channelName == '关键词推广'){
						tempdata[13] = item.click
						tempdata[14] = item.alipayConversion
						tempdata[15] = item.alipayCnt
						tempdata[16] = item.roi1d
					}
					if(item.module == '流量分析_广告归因'  && item.channelName == '全站推广'){
						tempdata[17] = item.click
						tempdata[18] = item.alipayConversion
						tempdata[19] = item.alipayCnt
						tempdata[20] = item.roi1d
					}
					
				})
				data.push(tempdata)
				if(this.needhead){
					data.unshift(head)
				}
				
				//console.log(data)
				// let data = [
				// 	['姓名', '年龄', '城市'],
				// 	['张三', 25, '北京'],
				// 	['李四', 30, '上海'],
				// 	['王五', 28, '广州']
				// ]
				const text = this.formatDataForExcel(data)
				this.$copyText(text).then(
					() => {
						this.$message.success('复制成功')
					},
					() => {
						this.$message.error('复制失败')
					}
				);
			},
			getcost(row){
				return (row.paidClick && row.clickCost) ? (row.paidClick * row.clickCost).toFixed(2):null
			},
			getpayrate(row){
				return (row.paidClick && row.clickCost && row.gmv) ? (row.paidClick * row.clickCost/row.gmv * 100).toFixed(2) : null
			},
			dayChange() {
				//this.init()
			},
			modal_init() {
				//this.init()
			},
			search() {
				if (!this.goodsurl) {
					this.$message.error('请输入商品链接或商品ID')
					return
				}
				if (this.goodsurl.startsWith('http')) {
					let queryParams = new URLSearchParams(new URL(this.goodsurl).search)
					if (!queryParams.get('id')) {
						this.$message.error('商品ID获取失败')
						return
					}
					this.goodscode = queryParams.get('id')
				} else {
					this.goodscode = this.goodsurl
				}
				this.init()

			},
			reset() {
				this.$refs.competitivegoodsTable.reloadData([])
				this.goodsurl = null
				this.date = [
					this.$Moment().subtract(7, 'days').startOf('day').valueOf(),
					this.$Moment().subtract(1, 'days').endOf('day').valueOf(),
				]
			},
			init() {
				this.loading = true
				// console.log(this.date)
				// return
				this.$api.BICompetitivegoods.search({
					goodscode: this.goodscode,
					date: this.date,
					goodsurl: this.goodsurl
				}).then((res) => {
					this.$refs.competitivegoodsTable.reloadData(res)
					//this.tableData = res
					this.loading = false
					//console.log(res)
				}, () => {
					this.loading = false
				})
			},
			hide() {
				this.$emit('hide')
				//this.chart = null
			},
			exportDataEvent() {
				this.$refs.competitivegoodsTable.exportData({
					type: 'xlsx',
					filename: this.goodscode + '_' + this.$Moment(this.date[0]).format('YYYY-MM-DD') + '_' + this
						.$Moment(this.date[1]).format('YYYY-MM-DD')
				})
			},
			formatDataForExcel(data) {
				let text = '';

				if (Array.isArray(data)) {
					if (Array.isArray(data[0])) {
						// 二维数组
						text = data.map(row =>
							row.map(cell => {
								if (cell === null || cell === undefined) return '';
								const cellStr = String(cell);
								// 处理特殊字符
								if (cellStr.includes('\t') || cellStr.includes('\n') || cellStr.includes('"')) {
									return '"' + cellStr.replace(/"/g, '""') + '"';
								}
								return cellStr;
							}).join('\t')
						).join('\n');
					} else {
						// 一维数组
						text = data.map(cell => {
							if (cell === null || cell === undefined) return '';
							const cellStr = String(cell);
							if (cellStr.includes('\t') || cellStr.includes('\n') || cellStr.includes('"')) {
								return '"' + cellStr.replace(/"/g, '""') + '"';
							}
							return cellStr;
						}).join('\t');
					}
				} else if (typeof data === 'string') {
					text = data;
				} else {
					text = String(data);
				}

				return text;
			},
		},
		components: {
			datePicker,
			taskIndex,
			systemtaskIndex
		}
	}
</script>